<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <kendo-datasource ref="datasourceQuestion"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <h2>{{ $t('faq.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <h3>{{ $t('faq.Question') }}</h3>
            <kendo-listbox :data-source-ref="'datasourceQuestion'"
                           :data-text-field="'Frage'"
                           :data-value-field="'Prim'"
                           :template="template"
                           @change="onQuestionChanged"
                           style="width:60vw;">
            </kendo-listbox>
            <br />
            <h3>{{ $t('faq.Answer') }}</h3>
            <div ref="answerHeader"
                    style="width:60vw;background-color:white;font-size:large;">
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';
    import { ListBox } from '@progress/kendo-listbox-vue-wrapper';
    import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
    import kendo from '@progress/kendo-ui';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-listbox': ListBox,
            'kendo-datasource': DataSource,
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/FAQ"
        },
        methods: {
            onQuestionChanged(e){
                const element = e.sender.select();
                const dataItem = e.sender.dataItem(element[0]);
                const header = this.$refs.answerHeader;
                header.innerHTML = dataItem.Antwort;
            },
            template: function (e) {
                var template = kendo.template('<h3 style="color:black">#=Frage#</h3>');
                return template(e);
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>